import moment from 'moment';

angular.module("app")
.service('LoginService', ['$http', '$q', 'Restangular', '$rootScope', 'logService', '$httpParamSerializer', '$state', '$timeout', function ($http, $q, Restangular, $rootScope, logService, $httpParamSerializer, $state, $timeout) {
    const loginErrorMessage = 'Usuario o contraseña no válidos.';
    const verificationErrorMessage = 'El código de verificación no es válido.';

    let refreshPromise;
    let transformUrlEncoded = function (data) {
            return $httpParamSerializer(data);
    };

    let coerceToBase64Url = function (thing) {
        // Array or ArrayBuffer to Uint8Array
        if (Array.isArray(thing)) {
            thing = Uint8Array.from(thing);
        }

        if (thing instanceof ArrayBuffer) {
            thing = new Uint8Array(thing);
        }

        // Uint8Array to base64
        if (thing instanceof Uint8Array) {
            var str = "";
            var len = thing.byteLength;

            for (var i = 0; i < len; i++) {
                str += String.fromCharCode(thing[i]);
            }
            thing = window.btoa(str);
        }

        if (typeof thing !== "string") {
            throw new Error("could not coerce to string");
        }

        // base64 to base64url
        // NOTE: "=" at the end of challenge is optional, strip it off here
        thing = thing.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");

        return thing;
    };

    let coerceToArrayBuffer = function (thing) {
        if (typeof thing === "string") {
            thing = thing.replace(/-/g, "+").replace(/_/g, "/");
            thing = thing.padEnd(thing.length + (4 - thing.length % 4) % 4, '=');
            var str = window.atob(thing);
            var bytes = new Uint8Array(str.length);
            for (var i = 0; i < str.length; i++) {
                bytes[i] = str.charCodeAt(i);
            }
            thing = bytes;
        }
        if (Array.isArray(thing)) {
            thing = new Uint8Array(thing);
        }
        if (thing instanceof Uint8Array) {
            thing = thing.buffer;
        }
        if (!(thing instanceof ArrayBuffer)) {
            throw new TypeError("could not coerce to ArrayBuffer");
        }
        return thing;
    };

    let service = {
        clearLoginStepError: function () {
            $rootScope.loginStepErrorMessage = null;
        },
        setLoginStepError: function (message = null) {
            $rootScope.loginStepErrorMessage = message || verificationErrorMessage;
        },
        get: function (key) {
            let value = localStorage.getItem(key);
            //fix para solucionar problema con plantillas en madrid
            if(value==null && key=="language") value = 'ES';
            return value;
        },
        loginUser: function (name, pw) {
            let deferred = $q.defer();
            let promise = deferred.promise;

            if (name != "" && pw != "") {
                $http.post((window as any).CONFIG.api_url + '/Auth/Login', { email: name, password: pw, withCredentials: true })
                    .then(function (response) {
                        deferred.resolve(response.data);
                    })
                    .catch(function (data, status, headers, config) {
                        deferred.reject('Wrong credentials.');
                    });
            } else {
                deferred.reject('Wrong credentials.');
            }
            return promise;
        },
        //creamos una sesión //setter
        set: function (key, val) {
            if (key == "token") Restangular.setDefaultRequestParams({ token: val });
            return localStorage.setItem(key, val)
        },
        //limpiamos una sesión
        unset: function (key) {
            if (key == "token") Restangular.setDefaultRequestParams({ token: "" });
            return localStorage.removeItem(key)
        },
        isLoggedIn: function () {
            if (localStorage.getItem("accessToken") != null) {
                $http.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("accessToken");
                return true
            } else return localStorage.getItem("userId") != null;
        },
        wantToBeRemembered: function () {

            return localStorage.getItem("remember");
        },
        permissionExist: function (permission) {
            var value = localStorage.getItem("rolesPermissions");
            if (value != null) {
                var res = value.split(",");
                var index = res.indexOf(permission);
                if (index != -1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        closeSession: function () {
            $rootScope.islogged = false;
            //deleteCookie("token");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("rolesPermissions");
            localStorage.removeItem("userName");
            localStorage.removeItem("userId");
            localStorage.removeItem("accessTokenValidTo");
            localStorage.removeItem("aclEnabled");
            localStorage.removeItem("userGroupId");
            if (!localStorage.getItem("remember")) {
                localStorage.removeItem("name");
                localStorage.removeItem("user");
            }
            try {
                delete $http.defaults.headers.common.Authorization;
            } catch (e) { }
            $.get((window as any).CONFIG.api_url + "Auth/Logout", function () {
                location.replace("/");
            });
            
        },
        shouldRefreshToken: function(url) {
            return url.match(/api\/\/Auth\/Refresh/) == null && url.indexOf("/api") >= 0
                && new Date() > new Date(this.get("accessTokenValidTo"));
        },
        refresh: function () {
            if (!refreshPromise) {
                delete $http.defaults.headers.common["Authorization"];
                let defered = $q.defer();
                refreshPromise = defered.promise;

                delete $http.defaults.headers.common.Authorization;

                logService.debug("Refrescando token");
                let authService = localStorage.getItem("authService");
                if(authService == null) {
                    $http.post((window as any).CONFIG.api_url + "Auth/Refresh",
                        {RefreshToken: service.get('refreshToken'), AccessToken: service.get('accessToken')})
                        .then(function (response) {
                            if(response.status != 200) {
                                service.closeSession();
                                defered.reject(response);
                                $state.go("login");
                            } else {
                                service.saveTokenInfo(response.data, null, true);
                                defered.resolve(response);
                            }
                    }).catch(function (response) {
                        service.closeSession();
                        defered.reject(response);
                        $state.go("login");
                    });
                } else {
                    let parsedService = JSON.parse(authService);
                    logService.debug(parsedService);
                    let openid = JSON.parse(parsedService.openid_configuration);

                    $http({
                        method: "post",
                        url: openid.token_endpoint,
                        transformRequest: transformUrlEncoded,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        data: {
                            'client_id': parsedService.client_id,
                            'grant_type': 'refresh_token',
                            'refresh_token': service.get('refreshToken')
                        }
                    }).then(function (response) {
                        logService.debug("Token refrescado");
                        logService.debug(response.data);
                        $http.defaults.headers.common["Authorization"] = "Bearer " + response.data.access_token;
                        service.set("accessToken", response.data.access_token);
                        if(typeof(response.data.refresh_token) !== "undefined") {
                            service.set("refreshToken", response.data.refresh_token);
                        }
                        service.set("expires_in", response.data.expires_in);
                        service.set("accessTokenValidTo", new Date(response.data.expires_in * 1000 + Date.now()).toISOString());
                        defered.resolve(response);
                    });
                }
                refreshPromise.finally(() => refreshPromise = null);
            }

            return refreshPromise;
        },
        saveTokenInfo: function (data, loginData = null, newLogin = false) {
            if(!newLogin) {
                $http.defaults.headers.common["Authorization"] = "Bearer " + data.token.accessToken;
                service.set("accessToken", data.token.accessToken);
                service.set("refreshToken", data.refresh_token);
                service.set("accessTokenValidTo", data.token.validTo);
            } else {
                service.set("accessTokenValidTo", new Date(data.token.expires_in * 1000 + Date.now()).toISOString());
            }
            
            service.set("userName", data.user_name);
            service.set("user", data.user_name);
            service.set("userId", data.user_id);
            service.set("userIcon", data.user_icon);
            if(data.company_id != 0) {
                service.set("companyId", data.company_id);
            }
            if(loginData != null) {
                service.set("remember", loginData.remember);
            }
            if(data.roles_permissions != null) {
                service.set("rolesPermissions", data.roles_permissions);
            }
            if(data.language != null) {
                service.set("language", data.language);
                $http.defaults.headers.common["language_code"] = data.language;
            }
            if(data.acl_enabled != null) {
                service.set("aclEnabled", data.acl_enabled ? "1" : "0");
            }
            if(data.users_group_id != null) {
                service.set("userGroupId", data.users_group_id);
            }
        },
        aclEnabled: function () {
            return localStorage.getItem("aclEnabled") === "1";
        },
        userCanManageAcl: function (acl) {
            if (!acl || !acl.trim()) return true;
            const userId = parseInt(localStorage.getItem("userId") || "0", 10);
            const groupId = parseInt(localStorage.getItem("userGroupId") || "0", 10);
            if (!userId) return false;
            return acl.split(',').some(function (part) {
                var trimmed = part.trim();
                var colon = trimmed.indexOf(':');
                if (colon < 0) return false;
                var subject = trimmed.slice(0, colon);
                var level = trimmed.slice(colon + 1).toUpperCase();
                if (level !== 'D') return false;
                return subject === ('u' + userId) || (groupId && subject === ('g' + groupId));
            });
        },
        validateUser: function(loginData = null) {
            service.clearLoginStepError();
            return $http.post((window as any).CONFIG.api_url + 'Auth/validate/user', loginData)
                .then(function (result) {
                    if(result.data.success) {
                        return service.nextStep();
                    }

                    service.setLoginStepError(loginErrorMessage);
                    return result;
                })
                .catch(function (error) {
                    service.setLoginStepError(error?.data?.message);
                    return error;
                });
        },
        validateWebauthnFallback: function(loginData) {
            service.clearLoginStepError();
            if (!loginData.username || !loginData.password) {
                service.setLoginStepError(loginErrorMessage);
                return Promise.resolve({ success: false, registrationToken: null });
            }
            return $http.post((window as any).CONFIG.api_url + 'Auth/WebAuthn/FallbackValidate', {
                username: loginData.username,
                password: loginData.password
            }).then(function(result) {
                if (result.data.success) {
                    return result.data; // { success: true, registrationToken: string }
                }
                service.setLoginStepError(loginErrorMessage);
                return result.data;
            }).catch(function(error) {
                service.setLoginStepError(error?.data?.message);
                return { success: false, registrationToken: null };
            });
        },
        registerWebauthnCredential: function(token) {
            return new Promise(function(resolve, reject) {
                $http.post((window as any).CONFIG.api_url + 'Auth/WebAuthn/MakeCredentialOptions/' + token, null)
                    .then(function(resp) {
                        var opts = resp.data;
                        if (opts.status !== 'ok') { reject(opts.errorMessage); return; }

                        opts.challenge = coerceToArrayBuffer(opts.challenge);
                        opts.user.id = coerceToArrayBuffer(opts.user.id);
                        opts.excludeCredentials = (opts.excludeCredentials || []).map(function(c) {
                            c.id = coerceToArrayBuffer(c.id);
                            return c;
                        });
                        if (opts.authenticatorSelection.authenticatorAttachment === null) {
                            opts.authenticatorSelection.authenticatorAttachment = undefined;
                        }

                        navigator.credentials.create({ publicKey: opts }).then(function(newCred: any) {
                            var attestationObject = new Uint8Array(newCred.response.attestationObject);
                            var clientDataJSON = new Uint8Array(newCred.response.clientDataJSON);
                            var rawId = new Uint8Array(newCred.rawId);
                            var data = {
                                id: newCred.id,
                                rawId: coerceToBase64Url(rawId),
                                type: newCred.type,
                                extensions: newCred.getClientExtensionResults(),
                                response: {
                                    attestationObject: coerceToBase64Url(attestationObject),
                                    clientDataJSON: coerceToBase64Url(clientDataJSON)
                                }
                            };
                            return $http.post(
                                (window as any).CONFIG.api_url + 'Auth/WebAuthn/MakeCredential/' + token,
                                JSON.stringify(data),
                                { headers: { 'Content-Type': 'application/json' } }
                            ).then(function(resp: any) {
                                if (resp.data.status === 'ok') { resolve(true); }
                                else { reject(resp.data.errorMessage); }
                            });
                        }).catch(reject);
                    }).catch(reject);
            });
        },
        checkWebauthn: function() {
            service.clearLoginStepError();
            Restangular.all('Auth').customPOST({}, 'WebAuthn/AssertionOptions', {}).then(async function (makeAssertionOptions) {
                logService.debug(makeAssertionOptions);
                if (makeAssertionOptions.status === "ok") {
                    const challenge = makeAssertionOptions.challenge.replace(/-/g, "+").replace(/_/g, "/");
                    makeAssertionOptions.challenge = Uint8Array.from(atob(challenge), c => c.charCodeAt(0));

                    // fix escaping. Change this to coerce
                    makeAssertionOptions.allowCredentials.forEach(function (listItem) {
                        var fixedId = listItem.id.replace(/\_/g, "/").replace(/\-/g, "+");
                        listItem.id = Uint8Array.from(atob(fixedId), c => c.charCodeAt(0));
                    });

                    // ask browser for credentials (browser will ask connected authenticators)
                    let credential;
                    try {
                        credential = await navigator.credentials.get({ publicKey: makeAssertionOptions })
                    } catch (err) {
                        logService.error(err);
                        service.setLoginStepError();
                    }

                    try {
                        await service.verifyAssertionWithServer(credential);
                    } catch (e) {
                        logService.error(e);
                        service.setLoginStepError(e?.errorMessage || e?.message);
                    }
                } else {
                    service.setLoginStepError(makeAssertionOptions.errorMessage);
                }
            }).catch(function (error) {
                service.setLoginStepError(error?.data?.message);
            });
        },
        verifyAssertionWithServer: async function (assertedCredential) {
            if (!assertedCredential) {
                service.setLoginStepError();
                return;
            }

            logService.debug("Verifying assertion with server");
            logService.debug(assertedCredential);
            // Move data into Arrays incase it is super long
            let authData = new Uint8Array(assertedCredential.response.authenticatorData);
            let clientDataJSON = new Uint8Array(assertedCredential.response.clientDataJSON);
            let rawId = new Uint8Array(assertedCredential.rawId);
            let sig = new Uint8Array(assertedCredential.response.signature);
            let userHandle = new Uint8Array(assertedCredential.response.userHandle)
            const data = {
                id: assertedCredential.id,
                rawId: coerceToBase64Url(rawId),
                type: assertedCredential.type,
                extensions: assertedCredential.getClientExtensionResults(),
                response: {
                    authenticatorData: coerceToBase64Url(authData),
                    clientDataJSON: coerceToBase64Url(clientDataJSON),
                    userHandle: userHandle !== null ? coerceToBase64Url(userHandle): null,
                    signature: coerceToBase64Url(sig)
                }
            };

            return Restangular.all('Auth').customPOST(JSON.stringify(data), 'WebAuthn/MakeAssertionNew', {}, {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }).then(function (response) {
                if (response.status !== "ok") {
                    logService.error("Error doing assertion");
                    logService.error(response.errorMessage);
                    service.setLoginStepError(response.errorMessage);
                    return;
                }
                service.clearLoginStepError();
                return service.nextStep();
            }).catch(function (error) {
                service.setLoginStepError(error?.data?.message);
                return error;
            });
        },
        validateAuthenticator: function(loginData) {
            if (loginData.authenticator_code.length === 6) {
                service.clearLoginStepError();
                const data = {
                    code: loginData.authenticator_code,
                };
                return $http.post((window as any).CONFIG.api_url + 'Auth/Validate/Authenticator', data)
                    .then(function (result) {
                        if (result.data.success) {
                            return service.nextStep();
                        }

                        service.setLoginStepError();
                        return result;
                    })
                    .catch(function (error) {
                        service.setLoginStepError(error?.data?.message);
                        return error;
                    });
            }

            service.setLoginStepError();
        },
        validateYubicoOTP: function(loginData) {
            if (loginData.yubico_otp.length > 0) {
                service.clearLoginStepError();
                const data = {
                    code: loginData.yubico_otp
                };
                return $http.post((window as any).CONFIG.api_url + 'Auth/Validate/YubicoOTP', data)
                    .then(function (result) {
                        if (result.data.success) {
                            return service.nextStep();
                        }

                        service.setLoginStepError();
                        return result;
                    })
                    .catch(function (error) {
                        service.setLoginStepError(error?.data?.message);
                        return error;
                    });
            }

            service.setLoginStepError();
        },
        reset: function() {
            return $http.post((window as any).CONFIG.api_url + 'Auth/Reset', {})
                .then(function() {
                    $state.go('authinit', {}, { reload: true });
                });
        },
        loginExternal: function(service) {
            logService.info("External login with " + service.name);
            $http.get((window as any).CONFIG.api_url + 'Auth/Challenge/' + service.id)
                .then(function (result) {
                    location.href = result.data;
                });
        },
        nextStep: function(processId = null) {
            let url = (window as any).CONFIG.api_url + 'Auth/next';
            if(processId != null) {
                url += '/' + processId;
            }
            return $http.get(url)
                .then(function (response) {
                    if(response.status === 202) {
                        service.getAuthInfo();
                    } else {
                        service.clearLoginStepError();
                        const authenticatorRegistrationToken = response.data?.AuthenticatorRegistrationToken || response.data?.authenticatorRegistrationToken;
                        if (authenticatorRegistrationToken) {
                            $state.go('authregisterauthcode', { token: authenticatorRegistrationToken });
                            return response.data;
                        }
                        $rootScope.step = response.data;
                        return response.data;
                    }
                });
        },
        getAuthInfo: function() {
            $http.get((window as any).CONFIG.api_url + 'Auth/info').then(function (response) {
                if(response.data.success) {
                    $rootScope.loginProcess = false;
                    service.saveTokenInfo(response.data.info, null, true);
                    Restangular.one("Companies", response.data.info.company_id).get().then(function (result) {
                        localStorage.setItem("userInactivityTimeout", result.user_inactivity_timeout);
                        service.resetInactivityTimeoutDate();
                        $timeout(function(){ service.LogoutByTimer() } , 1 * 60 * 1000); // 1 minutes
                    });

                    $state.go('dashboard.list');
                }
            });
        },
        resetInactivityTimeoutDate: function() {
            if(service.isLoggedIn()) {
                const timeout = parseInt(localStorage.getItem("userInactivityTimeout"));
                const date =  moment().add(timeout, 'minutes').toISOString();
                localStorage.setItem("inactivityTimeoutDate", date);
            }
        },
        LogoutByTimer: function() {
            const dateStr  = new Date(localStorage.getItem("inactivityTimeoutDate"));
            console.log(dateStr);
            if(moment().isAfter(dateStr)) {
                logService.debug("Logout by timer");
                service.closeSession();
                $state.go('authinit');
            }
            $timeout(function(){ service.LogoutByTimer() } , 1 * 60 * 1000); // 1 minutes
        }
    };
    return service;
}]);
